import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import { USER_QUERY_KEYS } from './keys';

import { fetchUserAllocationsWithoutPagination } from 'services/user';
import type { AllocationItem } from 'interface/allocation';
import type { QueryObject } from 'interface/queryParam';

type UserAllocationFilter = QueryObject & {
  userId?: string | number;
};

function isAllocationItemArray(data: unknown): data is AllocationItem[] {
  return Array.isArray(data);
}

export function useFetchUserAllocations(
  filter: UserAllocationFilter,
  shouldFetch = true
): UseQueryResult<AllocationItem[], Error> {
  return useQuery<unknown, Error, AllocationItem[]>({
    queryKey: [USER_QUERY_KEYS.ALLOCATIONS, filter.userId],
    queryFn: () => fetchUserAllocationsWithoutPagination(filter) as Promise<unknown>,
    enabled: shouldFetch && Boolean(filter.userId),
    select: (data) => (isAllocationItemArray(data) ? data : []),
  });
}
